let logApiHost = '';
switch (process.env.NODE_ENV) {
    // ↓ 开发环境
    case 'development':
        logApiHost = 'http://10.22.1.11:8039/';
        // logApiHost = 'http://10.22.1.18:8039';
        break;
    // ↓ 生产环境
    case 'production':
        logApiHost = 'http://10.22.1.117:8039';
        break;
};
const loginBase = `${logApiHost}Wenda/Publics/`;
const adminBase = `${logApiHost}Wenda/Admin/`;
const API = {
    logApiHost: logApiHost,
    loginBase:loginBase,
    adminBase:adminBase,
    // 登录
	loginUrl: loginBase + 'signin',
    //退出登录
    logOut: loginBase + 'signout',
    //获取下拉框数据
    realtionData:adminBase + "getComboboxJson",
    // 问题搜索,新增，编辑，删除
    questionSearch:adminBase + "question",
}

export default API